export const getStreamId = isPrivate => `@@collectionPopup-${isPrivate ? 'private' : 'public'}`;
